function LootBoyApiError(errorJson, response = {}) {
  Error.call(this);
  this.statusCode = errorJson.statusCode;
  this.status = response.status;
  // TODO? this.name = errorJson.name;
  this.message = errorJson.message;
  this.messageId = errorJson.messageId;
  this.detail = errorJson.detail;
  this.errorCode = errorJson.errorCode;
}

LootBoyApiError.prototype = Error.prototype;

function handleResponse(response, expectedStatusCode, description) {
  if (expectedStatusCode === response.status) {
    if (response.status === 204) {
      return Promise.resolve();
    }
    return response.json();
  }

  const contentType = response.headers.get('content-type');

  if (contentType && contentType.indexOf('application/json') >= 0) {
    return response.json().then((errorJson) => {
      // eslint-disable-next-line @typescript-eslint/no-throw-literal
      throw new LootBoyApiError(errorJson, response);
    });
  }

  throw new Error(
    `${description || 'Request'} failed with status code ${response.status}.`,
  );
}

module.exports = {
  handleResponse,
  LootBoyApiError,
};
